<div class="flex flex-column w-full overflow-hidden">
    <app-inbox-dashboard class="w-full"></app-inbox-dashboard>
    <div class="w-full flex flex-column shadow-md surface-ground overflow-hidden flex-1 flex mt-3">
        <p class="border-bottom-1 surface-border px-4 py-3 h5 font-bold">
            {{ 'default-cm-inbox' | translate: 'Inbox' }}
        </p>
        @if (currentTask) {
            <div class="border-bottom-1 surface-border px-4 py-3">
                <div class="flex justify-content-between align-items-center w-full">
                    <div class="flex align-items-center gap-3">
                        @if (currentTask.isFilterVisible) {
                            <app-inbox-filters
                                #filterComponent
                                [filterArray]="currentTask"
                                [formValue]="filterObject"
                                (applyFilterChange)="onApplyFilterChange($event)"
                                (onClearAllFilters)="onClearAllFilters()"
                            ></app-inbox-filters>
                            <span class="flex flex-wrap gap-1">
                                @for (option of filterChipsConfig; track option; let i = $index) {
                                    @if (i < visibleChipCount) {
                                        <platform-chip [value]="option.value" (onRemove)="removeFilterChip(i)">
                                        </platform-chip>
                                    }
                                }
                                @if (filterChipsConfig.length > visibleChipCount) {
                                    <platform-count-dropdown
                                        [items]="filterChipsConfig | slice: visibleChipCount"
                                        [count]="filterChipsConfig.length - visibleChipCount"
                                        (onRemove)="removeFilterChip($event + visibleChipCount)"
                                    ></platform-count-dropdown>
                                }
                                <platform-chip
                                    value="{{ 'default-cm-clearAll' | translate: 'Clear all' }}"
                                    (onClick)="onClearAllFilters()"
                                    [removable]="false"
                                    [disabled]="filterChipsConfig.length === 0"
                                    [ngClass]="{
                                        'cursor-pointer': filterChipsConfig.length > 0,
                                    }"
                                ></platform-chip>
                            </span>
                        }
                    </div>
                    <div class="flex flex-1 gap-4 justify-content-end align-items-center">
                        @if (currentTask.saveFilter) {
                            @if (buttonOrDropdown === 'button') {
                                <p-button [disabled]="filterChipsConfig.length === 0" (onClick)="onSaveFilter({})">
                                    {{ 'default-cm-saveFilter' | translate: 'Save filter' }}
                                </p-button>
                            } @else {
                                <p-dropdown
                                    optionLabel="undefined"
                                    #dropdown
                                    [options]="filterConfigService.dropDownActions"
                                    appendTo="body"
                                    (onShow)="filterConfigService.dropdownIconClass = 'pi pi-chevron-up'"
                                    (onHide)="filterConfigService.dropdownIconClass = 'pi pi-chevron-down'"
                                    styleClass="w-full border-none dropdown-button hover:bg-primary-300 bg-primary-700 dropdown-div height-36 flex justify-content-center align-items-center"
                                >
                                    <ng-template pTemplate="selectedItem">
                                        <div class="flex text-gray-50 justify-content-center align-items-center gap-2">
                                            <span class="text-medium">{{
                                                'default-cm-saveFilter' | translate: 'Save filter'
                                            }}</span>
                                            <i [class]="filterConfigService.dropdownIconClass"></i>
                                        </div>
                                    </ng-template>
                                    <ng-template let-item pTemplate="item">
                                        <div class="flex align-items-center" (click)="triggerSelect(item, dropdown)">
                                            {{ item.defaultLabel | translate: item.label }}
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            }
                        }
                        <span (click)="refresh()" class="material-symbols-outlined cursor-pointer text-gray-300"
                            >refresh</span
                        >
                        @if (currentTask.columnVisibility) {
                            <app-inbox-columns
                                class="justify-content-end"
                                [currentTask]="currentTask"
                                (arrayEmitter)="applyColumn($event)"
                            >
                            </app-inbox-columns>
                        }
                    </div>
                </div>
            </div>
            <div
                class="h-4rem border-bottom-1 surface-border flex justify-content-between align-items-center px-4 py-3"
            >
                <app-inbox-list [inboxtask]="inboxTask" [(selectedTask)]="selectedTask"></app-inbox-list>

                <!-- pagination part starting -->
                <div class="flex pagination gap-16 align-items-center p-3 justify-content-end">
                    <span class="text-md">{{ 'default-cm-showBy' | translate: 'Show by' }}</span>
                    <p-dropdown
                        [options]="pageSizeOptions"
                        optionLabel="viewValue"
                        optionValue="value"
                        styleClass="w-min text-sm "
                        [dropdownIcon]="dropdownIconClass"
                        appendTo="body"
                        [(ngModel)]="filterOptions.pageSize"
                        [autoDisplayFirst]="true"
                        (onChange)="changePageSize($event)"
                        (onShow)="dropdownIconClass = 'pi pi-chevron-up'"
                        (onHide)="dropdownIconClass = 'pi pi-chevron-down'"
                    ></p-dropdown>
                    <div class="flex align-items-center gap-1 text-xsmall">
                        <i
                            [ngClass]="{ 'opacity-40 pointer-events-none': pagination.disablePaginationPrevious }"
                            class="pi pi-angle-left cursor-pointer pagination-arrow-icon"
                            (click)="changePage('decrement')"
                        ></i>
                        <span class="text-sm text-normal"
                            >{{ pagination.rangeStart }} -
                            {{ pagination.rangeEnd }}
                        </span>
                        <span class="pagination-count text-sm text-normal">{{
                            'default-cm-of' | translate: 'of'
                        }}</span>
                        <span class="text-sm pagination-count text-normal"> {{ filterOptions.totalCases }}</span>
                        <i
                            [ngClass]="{
                                'opacity-40 pointer-events-none': pagination.disablePaginationNext,
                            }"
                            class="pi pi-angle-right cursor-pointer pagination-arrow-icon"
                            (click)="changePage('increment')"
                        ></i>
                    </div>
                </div>

                <!-- pagination part end -->
            </div>
            <app-inbox-table
                [filterOptions]="filterOptions"
                (paginationChange)="getTasks($event)"
                (onRefresh)="getTasks($event)"
                class="flex-1 overflow-hidden"
                [caseData]="caseInstances"
                [currentTask]="currentTask"
                [taskType]="selectedDropdown"
                [inboxList]="inboxTask"
                [selectedTask]="selectedTask"
            ></app-inbox-table>
        }
    </div>
</div>
